import { siteTree } from '@/components/MainMenu/sitetree';
import type { MenuItem } from '@/types';
import { flattenSiteTree } from '@itx-data/ui-helpers';
import type { RouteLocationNormalized, RouteRecordRaw } from 'vue-router';

const items = flattenSiteTree<MenuItem>(siteTree.value);

//This function will allow us to fetch the route title from the sitetree.ts file if it was not specified in the route's meta
export function getSiteTitle(route: RouteRecordRaw | RouteLocationNormalized) {
  const src = route.path.replace(`${import.meta.env.VITE_APP_MARKDOWN_DOCS_ROUTE_BASE}`, '');
  const to = route.path;

  const siteItem = items.find(
    (itemRoute) =>
      (itemRoute.src && itemRoute.src.replace('.md', '') === src) ||
      (itemRoute.to && itemRoute.to === to)
  );

  return siteItem ? siteItem.title : undefined;
}
